const TIME_FORMAT_OPTIONS = {
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
};

const DATE_TIME_FORMAT_OPTIONS = {
  month: 'short',
  day: 'numeric',
  ...TIME_FORMAT_OPTIONS,
};

const isSameDay = (dateA, dateB) =>
  dateA.getFullYear() === dateB.getFullYear() &&
  dateA.getMonth() === dateB.getMonth() &&
  dateA.getDate() === dateB.getDate();

export const formatTimestamp = timestamp => {
  if (!timestamp) {
    return '';
  }

  const date = new Date(timestamp);

  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const now = new Date();

  if (isSameDay(date, now)) {
    return date.toLocaleTimeString('en-US', TIME_FORMAT_OPTIONS);
  }

  return date.toLocaleString('en-US', DATE_TIME_FORMAT_OPTIONS);
};
